import { gql } from '@/service/gql'
import { type ResultOf } from 'gql.tada'

// language=GraphQL
export const playParamsFrag = gql(`
    fragment playParams on PlayParams @_unmask {
        id
        containerIds
        selections @include(if: $isAuthenticated)
    }
`)

export type PlayParams = ResultOf<typeof playParamsFrag>
